import type { FunctionComponent } from 'react'

import { BodyS, PrimaryButton, SPACING } from '@monthio/design-system'
import { ModalBody } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const ModalBodyWrapper = styled(ModalBody)`
	display: flex;
	flex-direction: column;
	align-items: center;
`

const ModalButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${SPACING.xs};
	width: 100%;
`

const ModalText = styled(BodyS)`
	margin-top: 0px;
`

interface ContinueWithoutSelectionModalProps {
	onContinue: () => void
	text: string
}

export const ContinueWithoutSelectionModal: FunctionComponent<
	ContinueWithoutSelectionModalProps
> = ({ onContinue, text }) => {
	const { t } = useTranslation()

	return (
		<ModalBodyWrapper>
			<ModalText>{text}</ModalText>

			<ModalButtonWrapper>
				<PrimaryButton onClick={onContinue}>
					{t(
						'savingsCapacity-continueWithoutSelectionModal-noExtraordinaryItems-button',
					)}
				</PrimaryButton>
			</ModalButtonWrapper>
		</ModalBodyWrapper>
	)
}
